import {Menu} from "antd";
import {menuItems} from "./menuItems";
import {useAuth} from "@/lib/hook";
import {useParams, usePathname} from "next/navigation";
import {useEffect, useMemo, useState} from "react";
import {isShowLinkInNavBar, myLinks} from "@/lib/routes/myLinks";
import {parseRoute} from "@/lib/routes/accessRoute";

export const NavMenu = ({collapsed, setCollapsed}) => {
    const auth = useAuth()
    const params = useParams();
    const pathname = usePathname()
    const [selectedKeys, setSelectedKeys] = useState([])
    const [openKeys, setOpenKeys] = useState([]);

    useEffect(()=>{
        if (auth.status === 'authenticated'){
            const link = getRoute(pathname, params)

            if (link){
                const linkKey = link.parent_key ? link.parent_key : link.key
                const keys = getSelectedKeysByKey(mainMenu, linkKey)

                setSelectedKeys(()=>[...keys])
                setOpenKeys(()=>keys.slice(0,keys.length-1))
            }else {
                setSelectedKeys([])
                setOpenKeys([])
            }
        }
    }, [pathname, auth.status])

    const mainMenu = useMemo(()=>{
        const parseMenu = (menu) =>{
            return menu.filter((item)=>{
                if (item.children){
                    item.children = parseMenu(item.children)
                }

                return isShowLinkInNavBar(item, auth.user)
            })
        }

        if (auth.status === 'authenticated'){
            return parseMenu(menuItems)
        }

        return []
    }, [auth.status]);

    const getRoute = (pathname, params) =>{
        const url = parseRoute(params, pathname)

        return myLinks.getByUrl(url)
    }

    const getSelectedKeysByKey = (mainMenu, keyFind) =>{
        const getKeys = (menu, keys = []) => {
            menu.forEach(({key, children, type}) => {
                if (key === keyFind && type !== 'group') {
                    keys.push(key);
                }
                if (children && !keys.length) {
                    const k = getKeys(children, keys);

                    if (k.length && type !== 'group'){
                        keys.push(key);
                    }
                }
            });

            return keys;
        }

        return getKeys(mainMenu).reverse()
    }

    const onOpenChange = (keys) =>{
        if (!collapsed){
            const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1)
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    }


    return (
        <div className={'ant_menu_wrapper'}>
            <Menu
                className={'menu'}
                openKeys={openKeys}
                mode="inline"
                items={mainMenu}
                selectedKeys={selectedKeys}
                inlineIndent={15}
                onOpenChange={onOpenChange}
                onClick={()=>{
                    if (setCollapsed){
                        setCollapsed()
                    }
                }}
            />
        </div>
    );
}